<template>
    <InvoiceModifier @make-corrective-invoice="correctInvoice"></InvoiceModifier>
</template>

<script>
import InvoiceModifier from '@/components/InvoiceModifier.vue'
import { makeCorrectiveInvoice } from '@/composables/invoiceService'
import popups from '@/hooks/popups';
import router from '@/router'

export default {
    components: {InvoiceModifier},
    setup() {
        const { errorToast, successToast } = popups()
        const correctInvoice = async function (invoice) {
            if (invoice.n_invoice && !invoice.correcting_reason) { errorToast("Selecciona una serie"); return }
            if (!invoice.serie) { errorToast("Selecciona una serie"); return }

            invoice.correcting_reason_code = invoice.correcting_reason ?invoice.correcting_reason.code : null
            invoice.customer.dni ? invoice.student_id=invoice.customer.id : invoice.account_id=invoice.customer.id
            let response = await makeCorrectiveInvoice(invoice)
            if (response.data.success) {
                successToast('Factura rectificada correctamente')
                router.push({name:'invoices'})
            } else {
                errorToast('Error rectificando factura')
            }
        }
        return {
            correctInvoice
        }
    }

}

</script>